// © Sitecore Corporation A/S. All rights reserved. Sitecore® is a registered trademark of Sitecore Corporation A/S.
import { getBrowserId, getCloudSDKSettingsBrowser as getCloudSDKSettings, getEnabledPackageBrowser as getEnabledPackage, getSettings, handleGetSettingsError } from '@sitecore-cloudsdk/core/internal';
import { getCookieValueClientSide } from '@sitecore-cloudsdk/utils';
import { ErrorMessages, PACKAGE_NAME } from '../consts';
import { awaitInit } from '../init/browser/initializer';
import { eventQueue } from './eventStorage';
/**
 * A function that adds event to the queue
 *
 * @param eventData - The required/optional attributes in order to be send to SitecoreCloud API
 */
export async function addToEventQueue(eventData) {
    await awaitInit();
    if (getEnabledPackage(PACKAGE_NAME)?.initState) {
        const settings = getCloudSDKSettings();
        const id = getCookieValueClientSide(settings.cookieSettings.name.browserId);
        const queueEventPayload = {
            eventData,
            id,
            settings: settings
        };
        eventQueue.enqueueEvent(queueEventPayload);
    }
    else {
        const settings = handleGetSettingsError(getSettings, ErrorMessages.IE_0014);
        const id = getBrowserId();
        const queueEventPayload = {
            eventData,
            id,
            settings
        };
        eventQueue.enqueueEvent(queueEventPayload);
    }
}
